import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'redux-first-history';
import { fetchDetailsHeader, fetchDocumentsCount } from 'src/services/cases.service';

// import // emptyInboxMessages,
// // stopMessagingRequest,
// // clearAllMessagesAndCounts,
// // runMessagingMonitor,
// 'src/ui/features/Messaging/state/messagingActions';
import {
  getCountsPending,
  getCaseMessagesCountsPending,
  storeCaseManagerId,
  storeCaseDetails,
  getLineManagersCount,
  resetCasesCounts,
  getMessagesCount,
  setCaseLoading,
} from '../state/casesActions';
import ClientManagerCasesDetailsPres from 'src/ui/features/Cases/presentational/ClientManagerCasesDetailsPres';
import { CASES_URL } from 'src/constants/constants.js';
import {
  isEYProSelector,
  isApplicantSelector,
  isCorpClientSelector,
  isCorporateClientLineManagerSelector,
} from 'src/ui/features/Login/state/loginReselect';
import { addToHistory, showNotification } from 'src/utils/utilsActions';
import Spinner from 'src/ui/library/Spinner/Spinner';
import { fnShowNewDashboard, fnGetIsAllDataFlag } from 'src/helpers/commonFunctions';

class ClientManagerCasesDetailContainer extends Component {
  viewTypes = {
    0: 'myCase',
    1: this.props.isCorpClientLineManager ? null : 'teamCase',
  };

  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      tab: 0,
      activeCaseTypeId: this.props.teamCases ? 1 : 0,
      caseId: this.getCaseManagerId(),
      caseLMCount: 0,
      headerDetails: {},
      questionnaireDetails: {},
      caseQuestionnaireCount: null,
      contactsCount: 0,
      docCount: 0,
      caseClosed: false,
    };
  }

  componentDidMount() {
    if (this.props.openDocumentsTab) {
      this.setState({ tab: 2 });
    }
    this.getDetails();
    this.props.addToHistory(window.location.pathname, { id: this.getCaseManagerId() });

    // this.props.stopMessagingRequest();
    // this.props.emptyInboxMessages();
    this.props.resetCasesCounts();
    // this.props.clearAllMessagesAndCounts();
    // this.props.runMessagingMonitor();

    //this.getDocCount();
  }

  componentWillUnmount() {
    this.props.resetCasesCounts();
    // this.props.clearAllMessagesAndCounts();
  }

  componentDidUpdate(prevProps, prevState) {}

  getCaseManagerId = () => {
    const { match, storeCaseManagerId } = this.props;
    let { caseId } = match.params;

    //TODO: getLineManagersCount
    //caseManagerId = parseInt(caseManagerId, 10);

    storeCaseManagerId(caseId);
    //this.props.getLineManagersCount(caseManagerId);
    return caseId;
  };

  getDetails = async () => {
    const { storeCaseDetails, showNotification, history } = this.props;
    const isAllData = fnShowNewDashboard()
      ? fnGetIsAllDataFlag()
      : sessionStorage.getItem('dashboardType') != null && sessionStorage.getItem('dashboardType') === 'allData';
    const [detailsHeaderResult] = await Promise.all([fetchDetailsHeader(this.state.caseId, isAllData)]);

    if (detailsHeaderResult && !detailsHeaderResult.error && !detailsHeaderResult.errors) {
      storeCaseDetails(detailsHeaderResult);
      this.setState({
        isLoaded: true,
        headerDetails: detailsHeaderResult,
        contactsCount: detailsHeaderResult.contactsCount,
        caseClosed: detailsHeaderResult.currentCaseStatus === 'Closed',
      });
    } else {
      showNotification('You do not have access to this record.', { variant: 'error' });
      setTimeout(() => {
        history.goBack();
      }, 3000);
    }
  };

  getDocCount = async () => {
    const { caseId } = this.state;
    fetchDocumentsCount(caseId, false).then(res => {
      if (res && !res.error && !res.errors) {
        return this.setState({ docCount: res });
      }
    });
  };

  tabsHandler = (event, value, messagesContactInfo) => {
    if (value === 2) {
      // documents tab
      this.getDocCount();
    }
    this.setState({
      tab: value,
      messagesContactInfo,
    });
  };

  handleChangeCaseType = viewType => {
    const url = this.viewTypes[viewType] === 'teamCase' ? CASES_URL + '/team' : CASES_URL;
    this.props.history.push(url);
  };

  render() {
    const { isLoaded, caseId, headerDetails, contactsCount } = this.state;

    //const { isCorpClientLineManager } = this.props;

    if (!isLoaded) {
      return (
        <div style={{ marginTop: '10%' }}>
          <Spinner size={70} />
        </div>
      );
    } else {
      return (
        <ClientManagerCasesDetailsPres
          handleTabSelect={this.tabsHandler}
          tab={this.state.tab}
          caseId={caseId}
          headerDetails={headerDetails}
          onRefreshDetails={this.getDetails}
          caseLineManagersCount={this.props.caseLMCount}
          contactsCount={contactsCount}
          caseClosed={this.state.caseClosed}
          messagesContactInfo={this.state.messagesContactInfo}
          docCount={this.state.docCount}
          {...this.props}
        />
      );
    }
  }
}

const mapDispatchToProps = {
  getCount: getCountsPending,
  storeCaseDetails,
  getLineManagersCount,
  storeCaseManagerId,
  getCaseMessagesCountsPending,
  push,
  addToHistory,
  // emptyInboxMessages,
  // stopMessagingRequest,
  resetCasesCounts,
  // clearAllMessagesAndCounts,
  showNotification,
  // runMessagingMonitor,
  getMessagesCount,
  setCaseLoading,
};

const mapStateToProps = state => ({
  isEYPro: isEYProSelector(state),
  isApplicant: isApplicantSelector(state),
  isCorpClient: isCorpClientSelector(state),
  isCorpClientLineManager: isCorporateClientLineManagerSelector(state),
  caseMessagesCount: state.cases.messagesInfo.count,
  openDocumentsTab: state.documents.openDocumentsTab,
  caseLMCount: state.cases.caseLineManagersCount,
  isAllData: state.dashboard.dashboardType === 'allData',
  isCaseLoading: state.cases.isLoading,
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientManagerCasesDetailContainer);
